import React from "react";
import { Lock, AlertTriangle } from "lucide-react";

export default function LiveTrading() {
  return (
    <div className="space-y-4 relative" data-testid="live-trading-page">
      <h1 className="text-2xl font-medium tracking-tight">Live Trading</h1>

      <div className="relative surface rounded-sm p-12 overflow-hidden border-l-2 border-l-red-500">
        <div className="absolute inset-0 backdrop-blur-sm bg-black/30 pointer-events-none" />
        <div className="relative z-10 flex flex-col items-center text-center gap-4">
          <div className="w-20 h-20 rounded-full bg-red-900/40 border-2 border-red-600 flex items-center justify-center">
            <Lock size={36} className="text-red-400" />
          </div>
          <div className="uppercase text-xs tracking-[0.3em] text-red-400">Locked</div>
          <div className="text-2xl font-medium">Live order placement is disabled</div>
          <p className="max-w-2xl text-sm text-slate-400 leading-relaxed">
            <span className="text-amber-400 font-semibold">LIVE_TRADING_ENABLED=false</span>. This
            application is currently in <strong>Phase 1 — Paper Trading</strong>. Live trading requires
            successful completion of the gate criteria (20 sessions, 100 closed paper trades, positive expectancy,
            profit factor ≥ 1.20, drawdown ≤ 8%, and explicit human approval) and a separate isolated live
            execution layer. See the Algorithm page for the full spec.
          </p>
          <div className="flex items-center gap-2 mt-4 px-4 py-2 border border-amber-500/40 bg-amber-500/10 rounded-sm">
            <AlertTriangle size={14} className="text-amber-400" />
            <span className="text-xs text-amber-300">Do not attempt to bypass. Live orders never leave the browser directly.</span>
          </div>
        </div>
      </div>

      <div className="surface rounded-sm p-6">
        <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-3">Prerequisites</div>
        <ul className="text-xs text-slate-300 space-y-2">
          {[
            "LIVE_TRADING_ENABLED=true on the production backend",
            "App-user reauthentication with confirmation phrase",
            "Healthy Zerodha session, worker, and data feed",
            "No emergency stop active",
            "Paper-gate approval record (≥20 sessions & 100 closed trades)",
            "Successful 5-session shadow run (no order placement)",
            "Explicit human approval recorded after reviewing gate report",
          ].map((line, i) => (
            <li key={line} className="flex gap-3">
              <span className="text-slate-600 font-mono">{String(i + 1).padStart(2, "0")}</span>
              <span>{line}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
